import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { colour } from './tokens';
import { commentDate, commentsForExport, latestComment } from '../../utils/familyComments';

/**
 * The newest comment, on screen. Left out of the CSV: the hidden Comments column below carries every
 * comment there, so the export has the whole history in one place rather than the latest twice.
 *
 * `data-comment` marks what staff wrote, so a test guarding the rest of the screen against a parent's
 * previous value can leave the comments out of what it checks.
 */
export const latestCommentColumn = () => ({
    field: 'latest_comment',
    headerName: 'Latest comment',
    // Long comments end in an ellipsis and show in full on hover; the dialog has them all.
    flex: 1,
    minWidth: 150,
    sortable: false,
    filterable: false,
    disableExport: true,
    valueGetter: (params) => latestComment(params.row)?.note || '',
    renderCell: (params) => {
        const comment = latestComment(params.row);
        if (!comment) return null;
        return (
            <Box data-comment sx={{ minWidth: 0, lineHeight: 1.25 }} title={comment.note}>
                <Typography noWrap sx={{ fontSize: '13px', color: colour.body }}>{comment.note}</Typography>
                <Typography noWrap sx={{ fontSize: '11.5px', color: colour.faint }}>
                    {`${comment.addedBy || ''} · ${commentDate(comment.addedAt)}`}
                    {(params.row.comments || []).length > 1 ? ` · ${params.row.comments.length} in all` : ''}
                </Typography>
            </Box>
        );
    },
});

/**
 * Every comment, oldest first, in one cell. Hidden on screen (ApproverScreen's columnVisibilityModel)
 * and exported, as the parent code, mobile and email are.
 */
export const allCommentsColumn = () => ({
    field: 'comments',
    headerName: 'Comments',
    width: 300,
    sortable: false,
    filterable: false,
    valueGetter: (params) => commentsForExport(params.row),
});
